module.exports = __webpack_public_path__ + "static/media/news-sph-01.835bdb73.jpg";